import { type Auth0User } from '@/features/account/services/User/types'
import { customClaims } from '@/features/shared/serverUtils/auth/constants'

export const getAuth0Session = (auth0User: Auth0User | null | undefined) => {
  const userId = auth0User?.[customClaims.SHIPT_USER_ID]
  return {
    userId: Number(userId ?? 0),
    sessionData: auth0User,
    // this is true if the user has an authentication token, regardless of whether they have completed
    // the onboarding process or not. users who are authenticated but not yet onboarded will not have
    // a user id assigned to their account.
    isSessionLoading: auth0User === undefined,
    isSessionValid: Boolean(auth0User),
    // this is true only for authenticated users who have finished onboarding, which results in
    // a user id being created for their account.
    isFullyAuthenticated: Boolean(auth0User?.[customClaims.ONBOARDED]),
  }
}
